export const CONSUMER_TYPE = 'CONSUMER_TYPE';
export const CREDIT_CAPACITY = 'CREDIT_CAPACITY';
export const CREDIT_CAPACITY_STATUS = 'CREDIT_CAPACITY_STATUS';
export const DOMIC_SUBSCRIPTION_STATUS = 'DOMIC_SUBSCRIPTION_STATUS';
export const MERCHANT_PAYMENT = 'MERCHANT_PAYMENT';
export const PENDING_APPLICATION = 'PENDING_APPLICATION';
export const PROTECTED_APPLICATION = 'PROTECTED_APPLICATION';
export const TOTAL_APPLICATIONS = 'TOTAL_APPLICATIONS';
export const VALID_PAYMENT = 'VALID_PAYMENT';
export const USER_VERIFICATION = 'USER_VERIFICATION';
export const USER_BLOCK_STATUS = 'USER_BLOCK_STATUS';
